import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Subject } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatePipe } from '@angular/common';

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.css"]
})
export class UsersComponent implements OnInit {
  public userData = {
    username: []
  };
  public data;
  public submitted: boolean = false;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private dataService: DataService,
    private toastr: ToastrManager,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe
  ) 
  {}

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      rowCallback: (row: Node, data: Object, index: number) => {
        $("#check", row).unbind("click");
        $("#check", row).bind("click", () => {
          const index = this.userData.username.indexOf(data[2]);
          if ($("#check", row).is(":checked")) {
            if (index === -1) {
              this.userData.username.push(data[2]);
              console.log(this.userData.username);
              console.log(this.userData);
            }
          } else {
            this.userData.username.splice(index, 1);
            console.log(this.userData.username);
          }
          console.log(this.userData.username.length);
          if (this.userData.username.length > 1) {
            this.submitted = true;
          } else if (this.userData.username.length <= 1) {
            this.submitted = false;
          }
        });
       

        return row;
      }
    };
    this.spinner.show();
    setTimeout(() => {
      /** spinner ends after 2 seconds */
      this.spinner.hide();
    }, 2000);
    this.getUsersList();
  }
  getUsersList() {
    return this.dataService.getUsersList().subscribe((Data: any) => {
      console.log(Data);
      if (Data.Status == "Error") {
        // alert(Data.Error.message);
        this.toastr.errorToastr(Data.Error.message, 'Oops!');
      } else {
        this.data = Data.Data.Users;
        console.log(this.data);
        this.dtTrigger.next();
      }
    });
  }

  getDate( date){
    // console.log(this.datePipe.transform('2018-10-05T07:54:18.881Z'	, 'medium'));
    // console.log(date)
    return this.datePipe.transform(date, 'medium')
  }

  deleteSingleUser(user) {
    this.userData.username = []
    if (this.userData.username.length == 0) {
      this.userData.username.push(user);
    }
    if (this.userData.username.length == 1) {
      this.deleteUser();
    }
  }
  deleteUser() {
    console.log(this.userData);
    var sure = confirm("Are you sure, You want to delete?");
    if (sure == true) {
      this.dataService.deleteUser(this.userData).subscribe((newData: any) => {
        if (typeof newData == "string") newData = JSON.parse(newData);
        console.log(newData);
        if (newData.Status == "Error") {
          // console.log(newData.Error.message);
          this.toastr.errorToastr(newData.Error.message, 'Oops!');
          this.router.navigate([''])

          // alert(newData.Error.message);
        } else if (newData.Status == "Success") {
          // alert("User Deleted Successfully");
          this.toastr.successToastr('User Deleted Successfully', 'Success!');
          location.reload();
          // this.router.initialNavigation()
        }
      });
    } else {
      console.log("Canceled");
    }
  }

  updateUserAttribute(username): void {
    console.log(username);
    this.router.navigate(["/update-user", { userName: username }]);
  }

  viewProfile(username): void {
    console.log(username);
    this.router.navigate(["/user-profile", { userName: username}]);
  }

  getUrl(attr) {
    // console.log(attr)
    for (var i = 0; i < attr.length; i++) {
      if (attr[i].Name == "picture") {
        // console.log(attr[i].Value)
        return attr[i].Value;
      }
    }
    return "https://s3.amazonaws.com/admin-panel-test/dummy.jpeg";
  }

  disableUser(event, username) {
    console.log(event.target.checked);
    console.log(username);
    if (event.target.checked === false) {
      this.dataService
        .disableUser({ username: username })
        .subscribe((res: any) => {
          console.log(res);
          if(typeof res == 'string'){
            res = JSON.parse(res)
          }
          if(res.Status == 'Success'){
            this.toastr.successToastr('User Disabled Successfully', 'Success!');
          }else{
            this.toastr.errorToastr(res.Error.message, 'Oops!');
            location.reload();
          }
        });
    }else{
      this.dataService
        .enableUser({ username: username })
        .subscribe((res: any) => {
          console.log(res);
          if(typeof res == 'string'){
            res = JSON.parse(res)
          }
          if(res.Status == 'Success'){
            this.toastr.successToastr('User Enabled Successfully', 'Success!');
          }else{
            this.toastr.errorToastr(res.Error.message, 'Oops!');
            location.reload();
          }
        });
    }
  }
}
